'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { render } from 'react-dom';
import { createHistory } from './utils/history'; // Rhumb

import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4'; // Redux

import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';
import { startApp } from './actions/AppActions';
import NotificationList from 'ReduxMessenger/components/NotificationList'; // Configure the router

import { Router } from 'react-router-dom';
import { getAppRootUrl } from './utils/urls';
import Routes from './components/Routes'; // I18n

import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import 'I18n/init/data/currency'; // Data Fetching Client

import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import UIApplication from 'UIComponents/app/UIApplication';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import { debug, setDebugKey, setDebugGate } from './utils/env';
import WindowDimensionsProvider from 'marketplace-ui-common/components/providers/WindowDimensionsProvider';
import MediaQueryStylesProvider from 'marketplace-ui-common/layout/components/MediaQueryStylesProvider';
import HSAnalyticsProvider from 'marketplace-ui-common/tracking/components/HSAnalyticsProvider';
import { getPartnerAwards } from './actions/AwardsActions';
import { getAcademyCertifications } from './actions/CertificationsActions';
import { getAccreditations } from './actions/AccreditationsActions';
import { fetchActiveServicesThunk } from './slices/serviceCatalogSlice';
import { fetchIntegrationsThunk } from './slices/integrationsSlice';
import FeedbackSurveyLoader from './components/FeedbackSurveyLoader';
const dataFetchingClient = new DataFetchingClient();
export default class App {
  constructor() {
    this.setDebugKey = (key, value) => setDebugKey(key, value);

    this.setDebugGate = (gate, ...args) => setDebugGate(gate, ...args);
  }

  start() {
    if (debug()) {
      window.appInstance = this;
    }

    this.store = configureStore();
    this.initialize().then(() => this.startApp()).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  }

  initialize() {
    return Promise.resolve();
  }

  registerI18n(I18nProvider) {
    return Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
  }

  getRootUrl() {
    return getAppRootUrl();
  }

  getRhumbConfig() {}

  getApplicationComponent() {
    return UIApplication;
  }

  startApp() {
    this.store.dispatch(startApp());
    this.store.dispatch(getPartnerAwards());
    this.store.dispatch(getAcademyCertifications());
    this.store.dispatch(getAccreditations());
    this.store.dispatch(fetchActiveServicesThunk());
    this.store.dispatch(fetchIntegrationsThunk());
    this.startRouter();
  }

  startRouter() {
    const history = createHistory(this.getRootUrl());
    const ApplicationComponent = this.getApplicationComponent();
    render( /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: /*#__PURE__*/_jsx(Provider, {
        store: this.store,
        children: /*#__PURE__*/_jsx(RhumbProvider, {
          config: this.getRhumbConfig(),
          history: historyAdapter(history),
          children: /*#__PURE__*/_jsx(HSAnalyticsProvider, {
            children: /*#__PURE__*/_jsx(MediaQueryStylesProvider, {
              children: /*#__PURE__*/_jsxs(WindowDimensionsProvider, {
                children: [/*#__PURE__*/_jsx(Router, {
                  history: history,
                  children: /*#__PURE__*/_jsxs(ApplicationComponent, {
                    children: [/*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(UIFloatingAlertList, {}), /*#__PURE__*/_jsx(Routes, {})]
                  })
                }), /*#__PURE__*/_jsx(FeedbackSurveyLoader, {})]
              })
            })
          })
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }

}